"use client";
import {
  tabs_default
} from "./chunk-XHIAUY5J.mjs";
import "./chunk-7ARJTFQR.mjs";
import "./chunk-TTZQXKQZ.mjs";
import {
  useTabs
} from "./chunk-IUT6HU4S.mjs";
import {
  tab_item_base_default
} from "./chunk-ML27DD5T.mjs";
export {
  tab_item_base_default as Tab,
  tabs_default as Tabs,
  useTabs
};
